require('angular');
require('angular-ui-bootstrap');
require('angular-cookies');
require('angular-translate');
require('angular-ui-router');
require('angular-sanitize');
require('angular-messages');
require('angular-message-format');

const app = angular.module('msi', [
  require('imports-loader?angular!@ordergroove/sdk-angular').default,
  require('./core'),
  require('./layout'),
  require('./toasts'),
  require('./spinner'),
  require('./analytics')
]);

module.exports = app.name;
